export const imgURL = "/images/";
export const BASE_URL = "https://backend.pps507.com/admin/";
export const BASE_URL2 = "https://backend.pps507.com/";
export const liveImgURL = "https://pps.zeeshannawaz.com/admin/images/";
